// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter } from '../_abstract/adapter';
import { ModuleDriver } from '../_contracts';
import { RelatedType } from '../../services';
import { getModuleBase } from '../_helpers/adapter';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class ReadMoreAdapter extends AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `ReadMoreModule` to the `ReadMoreToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        this.validate(object, {
            content: {
                presence: true
            },
            'content.articles': {
                presence: true,
                type: 'array',
                length: { minimum: 1, error: 'has to contain AT LEAST ONE related article!' }
            }
        });
        object.content.articles.forEach(article => {
            this.validate(article, {
                type: {
                    presence: true,
                    type: 'string',
                    equality: {
                        attribute: '-',
                        comparator: (type) => type === RelatedType.Content
                    }
                },
                value: {
                    presence: { allowEmpty: false }
                }
            });
        });
        const { articles, showThumbnails } = object.content;
        return {
            content: articles.map(article => article.value),
            meta: { showThumbnails },
            raw: `#READ[ articles: ${articles.map(article => article.value).join(', ')} | showThumbnails: ${showThumbnails} ]`,
            type: TokenType.ReadMore
        };
    }
    /**
     * Adapts (translates/maps) the passed-in `ReadMoreToken` to the `ReadMoreModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'array',
                length: {
                    minimum: 1,
                    error: 'has to contain AT LEAST 1 article ID!'
                }
            },
            meta: {
                presence: true,
                type: 'object'
            },
            'meta.showThumbnails': {
                presence: true,
                type: 'boolean'
            }
        });
        const { content: articles } = token;
        const { showThumbnails } = token.meta;
        return {
            ...getModuleBase(),
            content: {
                articles: articles.map(article => ({
                    type: RelatedType.Content,
                    value: article
                })),
                showThumbnails
            },
            driver: ModuleDriver.ReadMore
        };
    }
}
